window.addEventListener('b-card-slider-run', e => {
    const $cards = document.querySelectorAll('.b-card');
    if ($cards.length) {
        $cards.forEach($card => {
            const $hidden = $card.querySelector('.b-card__hover')
            const hiddenHeight = $hidden.offsetHeight;
            $card.style.setProperty('--hiddenHeight', hiddenHeight + 'px');
        })
    }
})